import { useMutation } from '@tanstack/react-query';
import {
  type ClientMonitoringEventDto,
  useApi,
} from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type UseSendPerformanceMonitoringEvent = Omit<
  Required<ClientMonitoringEventDto>,
  'type'
>;
export function useSendPerformanceMonitoringEvent() {
  const api = useApi();

  return useMutation<
    void,
    ExtendedAxiosError,
    UseSendPerformanceMonitoringEvent
  >({
    mutationKey: ['monitoring'],
    mutationFn: (r) =>
      api.monitoringApi
        .sendEvent({ ...r, type: 'performance' })
        .then((r) => r.data),
  });
}
